import React, { useEffect } from 'react';
import { Modal, Form, Input, Select, Button } from 'antd';

export const CreativeAdGroupForm = ({ visible, setVisible, selectedAdGroup, updateAdGroup, allAdGroups = [] }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (selectedAdGroup) {
      form.setFieldsValue({
        name: selectedAdGroup.name,
        creatives: selectedAdGroup.medias.map((media) => media.id),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAdGroup]);

  const validateUniqueName = (_, value) => {
    if (!value) return Promise.resolve();

    const lowerValue = value.toLowerCase().trim();
    const currentName = selectedAdGroup?.name?.toLowerCase().trim();

    // Allow if it's the same as current (editing)
    if (lowerValue === currentName) return Promise.resolve();

    // Check for duplicates across all ad groups (case-insensitive)
    const isDuplicate = allAdGroups.some(
      group => group.name.toLowerCase().trim() === lowerValue && group.id !== selectedAdGroup?.id
    );

    if (isDuplicate) {
      return Promise.reject(new Error("Ad group name already exists"));
    }

    return Promise.resolve();
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const onFinish = (values) => {
    updateAdGroup({
      adGroup: {
        ...values,
        medias: selectedAdGroup.medias
          .map((media) => media.id)
          .filter((mediaId) => !values.creatives.includes(mediaId)),
        id: selectedAdGroup.id,
      },
      type: 'disconnect',
    });
    setVisible(false); // Close the modal after form submission
  };
  const handleOk = () => {
    form.submit();
  };

  return (
    <div>
      <Modal
        title="Edit AdGroup"
        visible={visible}
        onCancel={handleCancel}
        className="creative-adgroup-modal"
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button type="primary" onClick={handleOk}>
            Submit
          </Button>,
        ]}
      >
        <Form form={form} onFinish={onFinish}>
          <Form.Item
            label="Name (Max 255 characters)"
            name="name"
            rules={[
              {
                required: true,
                message: "Please enter an ad group name",
              },
              {
                max: 255,
                message: "Ad group name must not exceed 255 characters",
              },
              {
                validator: validateUniqueName,
              },
            ]}
          >
            <Input maxLength={255} showCount />
          </Form.Item>
          <Form.Item
            label="Creatives"
            name="creatives"
            rules={[
              {
                required: true,
                message: 'Please select at least one creative',
              },
            ]}
          >
            <Select
              mode="multiple"
              showSearch={false}
              options={selectedAdGroup.medias.map((media) => ({
                value: media.id,
                label: media.name,
              }))}
            ></Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};
